// series-7 (bloque A cliente, #488 #489 #492 y la fecha, 24-sep-2026): LOS TEXTOS DE LA
// VENTANA DEL DOCUMENTO GRANDE, armados a partir de `affordability.series7`.
//
// Funciones puras: ni React, ni i18n, ni `lib/api`. La `t` y el idioma los pasa quien
// llama. El servidor calcula TODO (cuantas partes caben hoy, que falta, la combinacion
// mas barata y su precio); aqui solo se escoge la llave y se le pasan los numeros.
//
// La forma que manda el servidor (bajo una llave aparte, para que la app publicada no
// vea nada nuevo):
//   series7 = { total, now, saved, overflow, missing ("credits"|"space"|"both"|null),
//               active, cap, credits_have, credits_needed_all, credits_missing,
//               credits_reset_at (el INSTANTE del reinicio, ISO en UTC con su desfase,
//                                 p. ej. "2026-10-16T06:00:00+00:00"; o null),
//               offers: [{ kind ("pro"|"packs"|"pro_packs"), now, total,
//                          packs: [{ pack_id, credits, count }] (de mas grande a mas chico),
//                          pro, price_usd_web, rest_after, active_after, cap_after }] }
import { formatearFechaDeCaducidad } from './fechaDeCaducidad';

const RAIZ = 'dashboard:auto_split.s7.';

const esNumero = (v) => typeof v === 'number' && Number.isFinite(v);

// ---- la fecha del reinicio ----------------------------------------------------------

// El servidor manda el INSTANTE del reinicio, ISO en UTC ("2026-10-16T06:00:00+00:00"),
// y se le pasa tal cual al mismo formateador que el Panel usa para "Caduca {{date}}"
// (lib/fechaDeCaducidad.js): pinta el dia de ese instante en la zona de quien mira (las
// 03:00Z del 16 son el 15 en Mexico). Un DIA suelto ("2026-10-16"; el servidor solo lo
// mandaria si le llegara una fecha sin hora) se arma como el dia LOCAL, porque
// `new Date("2026-10-16")` es la medianoche UTC, que en Mexico (UTC-6) es el 15 a las 18:00.
// Lo que el formateador no pueda leer da '' (la variante sin fecha).
export function fechaDelReinicio(iso, idioma, ahora = new Date()) {
  if (!iso) return '';
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(iso));
  if (!m) return formatearFechaDeCaducidad(iso, idioma, ahora);
  const anio = Number(m[1]);
  const mes = Number(m[2]);
  const dia = Number(m[3]);
  const d = new Date(anio, mes - 1, dia, 12, 0, 0, 0);
  if (d.getFullYear() !== anio || d.getMonth() !== mes - 1 || d.getDate() !== dia) return '';
  return formatearFechaDeCaducidad(d, idioma, ahora);
}

// ---- la ventana: titulo, el renglon de las demas y el desborde -----------------------

// El muro con series7 (#492): nunca "impossible", "contact" ni "overcap". Al reanudar
// desde Pendientes las demas partes YA estan guardadas: como hoy, full o partial.
export function muroDeSeries7(s7, mode) {
  if (s7.now >= s7.total) return 'full';
  if (mode === 'resume') return 'partial';
  return s7.now === 0 ? 'k0' : 'partial';
}

// Cada texto tiene su "descriptor" ({ llave, valores }) y su version pintada (t aplicada).
// Los descriptores son lo que una prueba compara contra la tabla de casos del servidor.
//
// `count` (revision adversarial, hallazgo 3): cada descriptor le pasa a i18next el numero
// con el que concuerda su sustantivo (el total en los titulos; lo que espera en los
// renglones; lo que no cupo en U6; lo que espera espacio en U12). Desde el bloque T del
// remate (textos ratificados por Carlos el 25-sep-2026) los renglones tienen su llave
// `_one` al LADO de la de hoy, que se queda sin sufijo y hace de plural: i18next 23 (JSON
// v4) usa la `_one` con 1 y la de hoy con cualquier otro numero. Los titulos ahora y
// oferta no tienen `_one`: con 1 caen a la de hoy. oferta_todas SI la tiene desde el
// remate de post-t7-2b (firma de Carlos del 14-oct): el documento de una sola pieza dice
// "lo procesas ahora" en vez de "las 1 partes ahora".
//
// UN PEDAZO DENTRO DE UN TEXTO (bloque T): el de los creditos que faltan de U5, U5b y
// sin_mas_ambos* ("te falta 1 credito" / "te faltan N creditos") tiene su propio plural,
// con count = credits_missing, que no es el numero de partes del renglon. Viaja en los
// valores como otro descriptor, y se pinta AL PINTAR, antes que el texto que lo lleva: asi
// el descriptor del renglon sigue siendo comparable sin `t`. Va dos veces, como `faltan`
// (lo interpola el ES) y como `needed` (el EN), el mismo objeto, igual que la combinacion
// de una oferta viaja como `combinacion` y `combination`; se pinta una sola vez.
const esDescriptor = (v) => !!v && typeof v === 'object' && typeof v.llave === 'string';

function valoresPintados(t, valores) {
  const hechos = new Map();
  const out = {};
  Object.keys(valores || {}).forEach((k) => {
    const v = valores[k];
    if (esDescriptor(v)) {
      if (!hechos.has(v)) hechos.set(v, t(v.llave, v.valores));
      out[k] = hechos.get(v);
    } else {
      out[k] = v;
    }
  });
  return out;
}

const pintar = (t, d) => (d ? t(d.llave, valoresPintados(t, d.valores)) : null);

// El pedazo de los creditos que faltan (su count es credits_missing).
const pedazoDeCreditos = (s7) => ({ llave: `${RAIZ}faltan_creditos`, valores: { count: s7.credits_missing } });

export function descriptorDelTitulo(s7) {
  return { llave: `${RAIZ}ahora`, valores: { now: s7.now, total: s7.total, count: s7.total } };
}

export function tituloDeLaVentana(t, s7) {
  return pintar(t, descriptorDelTitulo(s7));
}

// Las partes que DE VERDAD esperan en Pendientes: `saved` (H2, decision del orquestador,
// 25-sep-2026). No total - now: con desborde eso contaba tambien las que no cupieron, y
// junto a U6 la ventana sumaba mas partes que el archivo. Sin desborde es el mismo numero.
// El servidor siempre manda `saved`; si faltara, sale de la misma suma
// (now + saved + overflow == total).
function lasQueEsperan(s7) {
  if (esNumero(s7.saved)) return Math.max(0, s7.saved);
  const desborde = esNumero(s7.overflow) ? s7.overflow : 0;
  return Math.max(0, (s7.total || 0) - (s7.now || 0) - desborde);
}

export function conDesborde(s7) {
  return !!s7 && esNumero(s7.overflow) && s7.overflow > 0;
}

// Con Pendientes lleno y desborde (saved 0) no espera ninguna parte. La revision del remate
// (hallazgo 1, 25-sep-2026) callaba el renglon ("Las otras 0 esperan" prometia lo que no
// pasa); desde el bloque T (DETENTE 3, textos ratificados el 25-sep-2026) dice que ahora no
// caben mas partes, segun lo que falte, y U6 sigue debajo. Sin count: "no caben mas partes"
// no concuerda con ningun numero.
function nadaMasCabe(s7, date) {
  if (s7.missing === 'credits') {
    return date
      ? { llave: `${RAIZ}sin_mas_creditos`, valores: { date } }
      : { llave: `${RAIZ}sin_mas_creditos_sin_fecha`, valores: {} };
  }
  if (s7.missing === 'space') {
    return { llave: `${RAIZ}sin_mas_espacio`, valores: { active: s7.active, cap: s7.cap } };
  }
  if (s7.missing === 'both') {
    const pedazo = pedazoDeCreditos(s7);
    const valores = { active: s7.active, cap: s7.cap, faltan: pedazo, needed: pedazo };
    return date
      ? { llave: `${RAIZ}sin_mas_ambos`, valores: { ...valores, date } }
      : { llave: `${RAIZ}sin_mas_ambos_sin_fecha`, valores };
  }
  return null;
}

// { llave, valores } del renglon de las demas, o null (missing null = no falta nada).
export function restoDeLaVentana(s7, idioma, ahora = new Date()) {
  const rest = lasQueEsperan(s7);
  const date = fechaDelReinicio(s7.credits_reset_at, idioma, ahora);
  if (rest === 0 && conDesborde(s7)) return nadaMasCabe(s7, date);
  if (s7.missing === 'credits') {
    return date
      ? { llave: `${RAIZ}resto_creditos`, valores: { rest, date, count: rest } }
      : { llave: `${RAIZ}resto_creditos_sin_fecha`, valores: { rest, count: rest } };
  }
  if (s7.missing === 'space') {
    return { llave: `${RAIZ}resto_espacio`, valores: { rest, active: s7.active, cap: s7.cap, count: rest } };
  }
  if (s7.missing === 'both') {
    // Bloque T: decia `credits: s7.credits_missing` ("te faltan {{credits}} creditos"
    // dentro del texto); ahora el pedazo, que concuerda solo (con 2 o mas creditos el texto
    // armado es el de antes, letra por letra).
    const pedazo = pedazoDeCreditos(s7);
    const valores = { rest, active: s7.active, cap: s7.cap, count: rest, faltan: pedazo, needed: pedazo };
    return date
      ? { llave: `${RAIZ}resto_ambos`, valores: { ...valores, date } }
      : { llave: `${RAIZ}resto_ambos_sin_fecha`, valores };
  }
  return null;
}

export function renglonDeLasDemas(t, s7, idioma, ahora = new Date()) {
  return pintar(t, restoDeLaVentana(s7, idioma, ahora));
}

export function descriptorDelDesborde(s7) {
  return conDesborde(s7)
    ? { llave: `${RAIZ}desborde`, valores: { overflow: s7.overflow, count: s7.overflow } }
    : null;
}

export function renglonDelDesborde(t, s7) {
  return pintar(t, descriptorDelDesborde(s7));
}

// ---- la leyenda de la barra y sus tramos (ajustes-1-3-0, Bloque A2, #499, 25-sep-2026) --
//
// Hasta esta tanda la leyenda con desborde era un telegrama ("Partes 1-16 ahora; en
// Pendiente de procesar por 60 dias: 8; para volver a subir despues: 4.") y sin desborde
// la ventana pintaba la de hoy. Carlos: "hay que ser mas claros". Con series7 la leyenda
// dice lo mismo que la barra, en frases enteras y con cada cifra al final: T5/T6/T7
// (cuantas se procesan ahora: plural, singular o ninguna) + T8 (las que se guardan en
// Pendientes, SOLO si hay) + T9 (las que no caben en ningun lado, SOLO si hay), separadas
// por un espacio y en ese orden. `k` es el numero del boton (sin el, el `now` del
// servidor, que es igual: los dos salen de `compute_affordability` con los mismos
// creditos, activos y plan). Sin s7, null: la ventana pinta la leyenda de hoy.
//
// Los tres tramos de la barra son las mismas tres cuentas: `ahora` (naranja),
// `pendientes` (el gris de Pendientes de hoy) y `despues` (un gris propio: las partes que
// hay que volver a subir; hasta esta tanda se pintaban como guardadas, y ese era el bug).
const RAIZ_BARRA = 'dashboard:parts_map.';

export function tramosDeLaBarra(s7, k) {
  if (!s7) return null;
  const ahora = esNumero(k) ? k : (s7.now || 0);
  return { ahora, pendientes: lasQueEsperan(s7), despues: conDesborde(s7) ? s7.overflow : 0 };
}

export function descriptoresDeLaLeyenda(s7, k) {
  const tramos = tramosDeLaBarra(s7, k);
  if (!tramos) return null;
  const out = [];
  out.push(tramos.ahora > 0
    ? { llave: `${RAIZ}leyenda_ahora`, valores: { n: tramos.ahora, count: tramos.ahora } }
    : { llave: `${RAIZ}leyenda_ahora_cero`, valores: {} });
  if (tramos.pendientes > 0) out.push({ llave: `${RAIZ}leyenda_pendientes`, valores: { saved: tramos.pendientes } });
  if (tramos.despues > 0) out.push({ llave: `${RAIZ}leyenda_despues`, valores: { overflow: tramos.despues } });
  return out;
}

const pintarLeyenda = (t, descriptores) => (descriptores ? descriptores.map((d) => pintar(t, d)).join(' ') : null);

export function leyendaDeSeries7(t, s7, k) {
  return pintarLeyenda(t, descriptoresDeLaLeyenda(s7, k));
}

// T10: los nombres de los tres colores de la barra, solo los tramos que existen y en el
// orden de la barra. `kind` es el del segmento de PartsMap (now, queued, overflow).
const NOMBRE_DEL_TRAMO = [
  ['ahora', 'now', 'nombre_ahora'],
  ['pendientes', 'queued', 'nombre_pendientes'],
  ['despues', 'overflow', 'nombre_despues'],
];

export function nombresDeLosTramos(s7, k) {
  const tramos = tramosDeLaBarra(s7, k);
  if (!tramos) return [];
  return NOMBRE_DEL_TRAMO
    .filter(([campo]) => tramos[campo] > 0)
    .map(([, kind, llave]) => ({ kind, llave: `${RAIZ_BARRA}${llave}` }));
}

// ---- las ofertas --------------------------------------------------------------------

export function ofertasDeSeries7(s7) {
  return Array.isArray(s7 && s7.offers) ? s7.offers : [];
}

// Pro primero; luego cada grupo de paquetes en el orden del servidor (de mas grande a mas
// chico): uno solo es "el paquete de N creditos", varios iguales "K paquetes de N
// creditos". Las piezas se unen con " mas " / " plus ".
export function combinacionDeOferta(t, oferta) {
  const piezas = [];
  if (oferta.pro) piezas.push(t(`${RAIZ}pieza_pro`));
  (oferta.packs || []).forEach((p) => {
    if (!esNumero(p.count) || p.count < 1) return;
    piezas.push(p.count === 1
      ? t(`${RAIZ}pieza_paquete`, { n: p.credits })
      : t(`${RAIZ}pieza_paquetes`, { k: p.count, n: p.credits }));
  });
  return piezas.join(t(`${RAIZ}pieza_union`));
}

// El ES interpola {{combinacion}} y el EN {{combination}}: se pasan las dos. La
// combinacion ya viene en el idioma de `t` (sus piezas son llaves del mismo namespace).
export function descriptorDeOferta(t, oferta) {
  const c = combinacionDeOferta(t, oferta);
  return oferta.now >= oferta.total
    ? { llave: `${RAIZ}oferta_todas`, valores: { combinacion: c, combination: c, total: oferta.total, count: oferta.total } }
    : { llave: `${RAIZ}oferta`, valores: { combinacion: c, combination: c, now: oferta.now, total: oferta.total, count: oferta.total } };
}

export function tituloDeOferta(t, oferta) {
  return pintar(t, descriptorDeOferta(t, oferta));
}

export function descriptorDeEspacioDeOferta(oferta) {
  return esNumero(oferta.rest_after) && oferta.rest_after > 0
    ? { llave: `${RAIZ}oferta_espacio`, valores: { rest: oferta.rest_after, active: oferta.active_after, cap: oferta.cap_after, count: oferta.rest_after } }
    : null;
}

export function renglonDeEspacioDeOferta(t, oferta) {
  return pintar(t, descriptorDeEspacioDeOferta(oferta));
}

// El formato de la web de hoy (CreditPackModal: `$${pack.price.toFixed(2)}`).
export function precioWebDeOferta(oferta) {
  return esNumero(oferta && oferta.price_usd_web) ? `$${oferta.price_usd_web.toFixed(2)}` : null;
}

export function ofertaAcentuada(ofertas) {
  const i = (ofertas || []).findIndex((o) => o.now >= o.total);
  return i >= 0 ? i : 0;
}

// A que compra lleva el clic: si la combinacion empieza por Pro, la de Pro; si son
// paquetes solos, la de paquetes (que no se puede abrir en un paquete concreto).
export function accionDeOferta(oferta) {
  if (oferta.kind === 'pro' || oferta.kind === 'pro_packs') return 'pro';
  if (oferta.kind === 'packs') return 'packs';
  return null;
}

// Todo lo que la ventana de SUBIDA pinta con `series7`, en una llamada: el texto y, en
// `llaves`, su descriptor (llave y valores). En web; el precio de la app lo pone
// lib/precioDeOferta.js con StoreKit. La prueba de los 36 casos (diseno 1.4) solo tiene
// que leer el fixture del servidor y comparar contra esto. `leyenda` (ajustes-1-3-0, A2)
// es la de la barra de partes en frases enteras, con el `now` del servidor; en `llaves`
// va la lista de sus descriptores (T5/T6/T7, T8 y T9), en ese orden.
export function textosDeSeries7(t, s7, { idioma, ahora = new Date() } = {}) {
  const ofertas = ofertasDeSeries7(s7);
  const acento = ofertaAcentuada(ofertas);
  const titulo = descriptorDelTitulo(s7);
  const resto = restoDeLaVentana(s7, idioma, ahora);
  const desborde = descriptorDelDesborde(s7);
  const leyenda = descriptoresDeLaLeyenda(s7);
  return {
    muro: muroDeSeries7(s7, 'upload'),
    titulo: pintar(t, titulo),
    resto: pintar(t, resto),
    desborde: pintar(t, desborde),
    leyenda: pintarLeyenda(t, leyenda),
    llaves: { titulo, resto, desborde, leyenda },
    ofertas: ofertas.map((o, i) => {
      const dTitulo = descriptorDeOferta(t, o);
      const dEspacio = descriptorDeEspacioDeOferta(o);
      return {
        titulo: pintar(t, dTitulo),
        precioWeb: precioWebDeOferta(o),
        espacio: pintar(t, dEspacio),
        accion: accionDeOferta(o),
        acento: i === acento,
        llaves: { titulo: dTitulo, espacio: dEspacio },
      };
    }),
  };
}
